import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';


export function validateDistrict(districts): ValidatorFn {

    let districtIds = Object.keys(districts).map(function (key) { return districts[key]['id']; });
    let districtNames = Object.keys(districts).map(function (key) { return districts[key]['name']; });

    // let result = 0;
    // states.foreach(obj => console.log(obj));
    return (control: AbstractControl): { [key: string]: any } => {

        if (!control.value) {

            return null;
        }

        if(districtNames.indexOf(control.value) > 0){
            return null;
        }

        return {'validateDistrict': {value: control.value}};
    };

}

@Directive({
    selector: '[validateDistrict]',
    providers: [{provide: [NG_VALIDATORS], useExisting: ValidateDistrictDirective, multi: true}]
})

export class ValidateDistrictDirective implements Validator {
    @Input()
    districts: string;

    validate(control: AbstractControl): { [key: string]: any } {

        return validateDistrict(this.districts)(control);
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/common/validators/district-validators.directive.ts